// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608232251/js/" + chunkId + "." + {"44":"1d2e8834","225":"26cdd50b","481":"da2074fe","486":"3e8169bc","770":"67352452"}[chunkId] + ".0.9879330023346478.chunk.js";
};